// extracted by mini-css-extract-plugin
module.exports = {"link":"menuItem-module--link--2lJl2","item":"menuItem-module--item--2Dvov","active":"menuItem-module--active--1jqnC"};